module.exports = __webpack_public_path__ + "img/default_logo.2a06bea7.png";